import Disableable, { Disable, Enable } from '../../../../../../interface/Disableable.js';
import EL, { HTMLELEMENT } from '../../../../../EL/EL.js';
import FIELD from '../../../../../DOM/form/fieldset/field/FIELD.js';
export default class INPUT extends FIELD {
    constructor(node, model) {
        super(node, HTMLELEMENT.INPUT, model);
        if (!model.attributes.required) {
            this.el.removeAttribute('required');
        }
        this.implement(new Disableable(this));
        this.on('enable', (event) => this.el.click());
    }
    setValue(value) {
        this.attributes.value = value;
        this.el.value = String(value);
        return this;
    }
    getValue() {
        return this.el.value;
    }
    checkValidity() {
        return this.el.checkValidity();
    }
    setCustomValidity(message) {
        this.el.setCustomValidity(message);
    }
}
export { Disable, Disableable, EL, Enable };
